import { defineMessages } from 'react-intl';

export default defineMessages({
  title_ContactUs: {
    id: 'contact-us.title.page',
  },
  title_Content: {
    id: 'contact-us.title',
  },
  contact_description: {
    id: 'contact-us.description',
  },
  requiredField: {
    id: 'required.field',
  },
  object: {
    id: 'contact-us.objet',
  },
  demandeInfo: {
    id: 'contact-us.demande-info',
  },
  message: {
    id: 'contact-us.content',
  },
  send: {
    id: 'report_a_bug_modal.send',
  },
  others: {
    id: 'contact-us.others',
  },
  reclamation: {
    id: 'contact-us.reclamation',
  },
  subscription: {
    id: 'contact-us.subscription',
  },
});
